import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { FileUploadService } from '../../services/file-upload.service';
import { RouteShareService } from '../../services/route-share.service';

export const documentResolver: ResolveFn<boolean> = async (route, _state) => {
  const fileUploadService: FileUploadService = inject(FileUploadService);

  const rss: RouteShareService = inject(RouteShareService);
  await fileUploadService.loadAllowedTypes();

  const id = route.parent?.params['id'] as string;
  rss.documents = (await fileUploadService.getFiles(id)).docs;

  const docId = route.firstChild?.params['docid'] as string;
  if (docId) {
    rss.document = rss.documents.find(doc => doc._id === docId);
    rss.documentChunks = await fileUploadService.getFileChunks(id, rss.document?.docSearchId ?? '');
  } else {
    rss.document = undefined;
    rss.documentChunks = undefined;
  }

  rss.selectableDocuments = await fileUploadService.getSelectableDocuments(id);
  return true;
};